.addPartner_AddPartner_88fb123{fill:var(--primary-color-1)}